const getToken = () => JSON.parse(localStorage.getItem("authentication"));

const config = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});

export default config;
